/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CustomQuestionnaireStep } from './CustomQuestionnaireStep';
import {
  CustomQuestionnaireStepFromJSON,
  CustomQuestionnaireStepFromJSONTyped,
  CustomQuestionnaireStepToJSON,
} from './CustomQuestionnaireStep';

/**
 * Adds nested create feature
 * @export
 * @interface CustomQuestionnaire
 */
export interface CustomQuestionnaire {
  /**
   *
   * @type {number}
   * @memberof CustomQuestionnaire
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaire
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaire
   */
  description: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaire
   */
  readonly createdBy: string;
  /**
   *
   * @type {string}
   * @memberof CustomQuestionnaire
   */
  readonly updatedBy: string;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaire
   */
  readonly createdAt: Date;
  /**
   *
   * @type {Date}
   * @memberof CustomQuestionnaire
   */
  readonly updatedAt: Date;
  /**
   *
   * @type {Array<CustomQuestionnaireStep>}
   * @memberof CustomQuestionnaire
   */
  steps: Array<CustomQuestionnaireStep>;
}

/**
 * Check if a given object implements the CustomQuestionnaire interface.
 */
export function instanceOfCustomQuestionnaire(value: object): value is CustomQuestionnaire {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('description' in value) || value['description'] === undefined) return false;
  if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
  if (!('updatedBy' in value) || value['updatedBy'] === undefined) return false;
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
  if (!('steps' in value) || value['steps'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireFromJSON(json: any): CustomQuestionnaire {
  return CustomQuestionnaireFromJSONTyped(json, false);
}

export function CustomQuestionnaireFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomQuestionnaire {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    name: json['name'],
    description: json['description'],
    createdBy: json['created_by'],
    updatedBy: json['updated_by'],
    createdAt: new Date(json['created_at']),
    updatedAt: new Date(json['updated_at']),
    steps: (json['steps'] as Array<any>).map(CustomQuestionnaireStepFromJSON),
  };
}

export function CustomQuestionnaireToJSON(
  value?: Omit<CustomQuestionnaire, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    description: value['description'],
    steps: (value['steps'] as Array<any>).map(CustomQuestionnaireStepToJSON),
  };
}
